// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  imageUrl: 'https://cdn.illpeoplemusic.com/imges/imgs/',
  apiBaseUrl: 'https://api-dev.illpeoplemusic.com/api/v2/',
  beatPlayUrl: 'https://d2o3vwndhrrwn8.cloudfront.net/play?beatid=',
  soundPlayUrl: 'https://d2o3vwndhrrwn8.cloudfront.net/play-sound?soundid=',
  amazonPlayUrl: 'https://cdn.illpeoplemusic.com/play?beatid=',
  amazonGetTicketUrl: 'https://x0by96g2pj.execute-api.ap-south-1.amazonaws.com/test/getticket?music=',
  amazonGetTicketUrlSound: 'https://qd3swvz3j9.execute-api.ap-south-1.amazonaws.com/prod/get-ticket',
  waveformApiUrl: 'https://2cbq8dyl48.execute-api.ap-south-1.amazonaws.com/prod/waveform',
  shareUrl: 'https://dev.beat22.com/',
  shareBeat22Url: 'https://beat22.com/',
  rozarPayDevKey: 'rzp_test_R8r1ilU4Z4ibtS',
  subscriptionType: "testing",
  calverTapId: "779-6R5-847Z",
  postHogKey: "phc_vtykjHcmtfXQp9KdvFf4U8P4n6Zi7qszyh6qHNRwp5Dh",
  postHogHost: "https://us.i.posthog.com",
  firebaseConfig : {
    apiKey: "AIzaSyDZkqZOYLf9pcj6TjNvAfKovD95Uz_llqc",
    authDomain: "illpeople-music.firebaseapp.com",
    projectId: "illpeople-music",
    storageBucket: "illpeople-music.appspot.com",
    messagingSenderId: "58360648302",
    appId: "1:58360648302:web:d66a78fd0f55c951374c7f",
    measurementId: "G-N6J1B7X0D9"
  },
  clientIdGoogle: '502950159647-31pmqonoss63fpk2fjcr79sb15qbersq.apps.googleusercontent.com'
};


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
